// Copied verbatim from the app repo's src/utils/ticketContract.js (spec 026
// S1/S3) — that file is the source of truth; keep this copy in sync by hand.
/**
 * Shared support-ticket vocabulary (spec 026, D13/D14 — task S1).
 *
 * The app, the dashboard and `functions/` all assert against this file rather
 * than restating the four states or the message cap, so the three surfaces
 * cannot drift out of sync with the Figma flow (node 8805:24295): four
 * lifecycle states, Reopen only from Resolved, and a locked composer once a
 * ticket is Closed.
 */
export const TICKET_STATUSES = ["open", "waiting_user", "resolved", "closed"];
export const STATUS_LABELS = { open: "Submitted", waiting_user: "Waiting for You", resolved: "Resolved", closed: "Closed" };
export const MESSAGE_MAX = 2000;
export const canUserReopen = (s) => s === "resolved";          // Figma: Reopen on the resolved card
export const composerLocked = (s) => s === "closed";           // "This support request is closed"
